import { AvailableWeek } from '../store/availableTimes/types'
import { ErrorResponse } from '../types/auth'
import { callApi } from '../utils/api'
import { endpoints } from './config'

interface GetEmployeeAvailableTimesParams {
  employeeGuid: string
  selectedDate: string
  appointmentDuration: number
}

export const getEmployeeAvailableTimes = async ({
  employeeGuid,
  selectedDate,
  appointmentDuration
}: GetEmployeeAvailableTimesParams): Promise<AvailableWeek | ErrorResponse<'Error'> | null> => {
  const response = await callApi<AvailableWeek | ErrorResponse<'Error'>>({
    path: endpoints.employeeAvailableTimes,
    body: {
      mitarbeiterGuid: employeeGuid,
      datum: selectedDate,
      terminDauer: appointmentDuration,
      ClientIp: ''
    }
  })

  if (!response.isOk && response.data && 'status' in response.data && response.data.status === 'Error') {
    return response.data
  }

  if (!response.isOk || !response.data) {
    return null
  }

  return response.data
}
